module.exports = __webpack_public_path__ + "static/media/manual.cef62f1c.pdf";